import { debounce } from './debounce'

export const registerNestedMenu = () => {
  if (document.querySelector('.menu-item-has-children')) {
    const darkArrowSrc =
      script_vars.template_root +
      '/dist/images/icons/controls/down-arrow-dark.svg'
    const whiteArrowSrc =
      script_vars.template_root +
      '/dist/images/icons/controls/down-arrow-white.svg'

    // Track scroll position to determine direction
    let lastScrollTop = 0

    // Track navbar state to avoid unnecessary updates
    let navbarHasFloat = false

    // Function to add arrow to menu item
    const addArrowToMenuItem = (item) => {
      const arrowImg = new Image()

      // Mobile view always gets dark arrows
      if (window.innerWidth < 1024) {
        arrowImg.src = darkArrowSrc
      } else {
        // Check if navbar has nav-float class
        const navbar = document.querySelector('.navbar')
        navbarHasFloat = navbar && navbar.classList.contains('nav-float')

        // Desktop with nav-float gets dark arrows, otherwise white
        arrowImg.src = navbarHasFloat ? darkArrowSrc : whiteArrowSrc
      }

      arrowImg.classList.add('sub-menu-arrow')
      item.appendChild(arrowImg)
    }

    // Function to update desktop menu arrows on scroll
    const updateDesktopArrows = (isScrollingUp) => {
      // Only update if we're on desktop and scrolling up (when nav-float gets added)
      // or if we're scrolling down and navbar currently has float (when nav-float gets removed)
      if (window.innerWidth >= 1024) {
        const navbar = document.querySelector('.navbar')
        const currentNavbarHasFloat =
          navbar && navbar.classList.contains('nav-float')

        // Only update if navbar state has changed
        if (currentNavbarHasFloat !== navbarHasFloat) {
          navbarHasFloat = currentNavbarHasFloat

          // Get all desktop menu arrows (excluding mobile menu)
          const desktopArrows = document.querySelectorAll(
            ':not(#menu-menu-header-mobile) .menu-item-has-children > a .sub-menu-arrow'
          )

          // Update arrow src based on navbar state
          desktopArrows.forEach((arrow) => {
            arrow.src = navbarHasFloat ? darkArrowSrc : whiteArrowSrc
          })
        }
      }
    }

    // Handle click events for menu items
    const handleMenuItemClick = (item) => {
      item.addEventListener('click', (e) => {
        // Only handle clicks for mobile view
        if (window.innerWidth < 1024) {
          e.preventDefault()
          item.nextElementSibling.classList.toggle('is-open')
          item
            .querySelector('.sub-menu-arrow')
            .classList.toggle('arrow-rotated')
        }
      })
    }

    // Get all menu items with children
    const menuItems = document.querySelectorAll('.menu-item-has-children > a')

    // Process all menu items
    Array.from(menuItems).forEach((item) => {
      addArrowToMenuItem(item)
      handleMenuItemClick(item)
    })

    // Handle window resize events
    window.addEventListener(
      'resize',
      debounce(function (event) {
        // Reset all submenus when switching to desktop view
        if (window.innerWidth >= 1024) {
          menuItems.forEach((item) => {
            item.nextElementSibling.classList.remove('is-open')
            const arrow = item.querySelector('.sub-menu-arrow')
            if (arrow) {
              arrow.classList.remove('arrow-rotated')
            }
          })
        }

        // Remove and re-add all arrows to update them based on current viewport
        menuItems.forEach((item) => {
          const oldArrow = item.querySelector('.sub-menu-arrow')
          if (oldArrow) {
            oldArrow.remove()
          }
          addArrowToMenuItem(item)
        })
      })
    )

    // Listen for scroll events to update desktop arrows when nav-float class changes
    window.addEventListener('scroll', function () {
      // Only process on desktop
      if (window.innerWidth >= 1024) {
        // Determine scroll direction
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop
        const isScrollingUp = scrollTop < lastScrollTop
        lastScrollTop = scrollTop

        // Only update arrows when scrolling up (when nav-float gets added)
        // or when scrolling down from a position where nav-float was active
        if (isScrollingUp || navbarHasFloat) {
          updateDesktopArrows(isScrollingUp)
        }
      }
    })
  }
}
